import { Component } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as zhLang } from './modules/i18n/vocabs/zh';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(private translationService: TranslationService) {
    // register translations
    this.translationService.loadTranslations(enLang, esLang, zhLang);
  }
}
